export function formatTimeFromSeconds(totalSeconds) {
    // Calculate hours, minutes, and seconds
    let hours = Math.floor(totalSeconds / 3600);
    totalSeconds %= 3600;
    let minutesLeft = Math.floor(totalSeconds / 60);
    let seconds = totalSeconds % 60;

    // Pad the minutes and seconds with leading zeros if needed
    let paddedHours = String(hours).padStart(2, '0');
    let paddedMinutes = String(minutesLeft).padStart(2, '0');
    let paddedSeconds = String(seconds).padStart(2, '0');

    // Format the time in HH:MM:SS
    return `${paddedHours}:${paddedMinutes}:${paddedSeconds}`;
}